import { CanMatchFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { RoutesSlugs } from "@app/routes-slugs";
import { IsAppFirstTimeOpenedUseCase } from "@app/core/user/domain/use-cases/is-app-first-time-opened.use-case";
import { Capacitor } from "@capacitor/core";

/**
 * The following guard is responsible for checking whether the user has previously accessed the application.
 * If so, it redirects them to the OnBoarding component, which provides a brief overview of the app's content.
 * @constructor
 */
export const NotFirstTimeUserGuard: CanMatchFn = () => {
  const isFirstTime = inject(IsAppFirstTimeOpenedUseCase).execute();
  if (isFirstTime && Capacitor.isNativePlatform()) {
    return inject(Router).createUrlTree(["/", RoutesSlugs.ONBOARDING]);
  }
  return true;
};
